import styled, { css } from 'styled-components';
import {
	ApButtonSecondary,
	ApRadio,
	colors,
} from '@alixpartners/ui-components';

import { ScrollContainer as ScrollContainerOriginal } from 'Details/styles';

// const MIN_WIDTH = '1135px';
const FULL_WIDTH = '100%';

export const Wrapper = styled.div`
	display: block;
	position: relative;
`;

export const LoadingContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	z-index: 10;
	background-color: rgba(255, 255, 255, 0.8);
`;

export const ScrollContainer = styled(ScrollContainerOriginal)`
	position: relative;
	z-index: 1;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 32px;
	min-width: calc(${FULL_WIDTH} + 32px);
	background-color: ${colors.white};
`;

export const HeaderTop = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const HeaderDropdownContainer = styled.div`
	width: 230px;
`;

export const HeaderContainer = styled.div`
	display: flex;
	align-items: center;
`;

export const HeaderLabel = styled.div`
	display: flex;
	font-size: 28px;
	font-weight: 500;
	color: #333333;
	margin-right: 16px;
`;

export const HeaderDescription = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${colors.grey5};
	margin-top: 12px;
`;

export const OrderedItemWrapper = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;

	${({ order }) =>
		order &&
		css`
			order: ${order};
		`};
`;

export const SecondaryContent = styled.div`
	min-width: ${FULL_WIDTH};
	background-color: ${colors.greyBg};
	padding: 32px;
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
`;

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: ${FULL_WIDTH};
	height: auto;
	padding: 24px 32px;
	background-color: ${colors.white};
	margin-bottom: 32px;
`;

export const TableContainer = styled.div`
	width: 748px;
`;

export const TopDataContent = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-top: 24px;
`;

export const NoDataContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const SortSelectorContainer = styled.div`
	display: flex;
	align-items: center;
	margin-top: 24px;
`;

export const SortText = styled.div`
	color: ${colors.grey5};
	font-weight: 400;
	font-size: 13px;
	line-height: 19px;
	letter-spacing: 0.3px;
`;

export const Radio = styled(ApRadio)`
	margin-left: 24px;
`;

export const CompaniesTopVendors = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;
	flex-wrap: wrap;
`;

export const ShowMore = styled(ApButtonSecondary)`
	margin: 24px auto 0;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 19px;
	color: black;
	flex: 1;
`;

export const LoadingBlock = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	padding: 2%;
`;
